import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatRippleModule } from '@angular/material/core';

@Component({
  selector: 'ctr-recommendation-card',
  imports: [MatRippleModule],
  templateUrl: './recommendation-card.component.html',
  styleUrl: './recommendation-card.component.scss',
})
export class RecommendationCardComponent {
  @Input() title: string | undefined | null;
  @Input() description: string | undefined | null;
  @Input() image: string | undefined;
  @Output() action: EventEmitter<void> = new EventEmitter<void>();

  onClick() {
    this.action.emit();
  }
}
